function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceQueueDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.36,10.91a.85.85,0,0,1,.79.81h0v1.92a.78.78,0,0,1-.79.8h-1a.84.84,0,0,1-.8-.8h0V11.77a1.06,1.06,0,0,1,.52-.8c.1,0,.1-.11.1-.11a5.64,5.64,0,0,0-5.34-4,5.74,5.74,0,0,0-5.33,4c0,.18.09.1.27.18a.75.75,0,0,1,.44.75v1.85a.86.86,0,0,1-.62.85c-.09.09,0,.18,0,.27a5.56,5.56,0,0,0,3.64,3.61c.45.09.18-.46,1-.46h1.51a.64.64,0,0,1,.62.65h0v.73a.65.65,0,0,1-.62.67H13.26c-.35,0-.62-.1-.7-.46a.45.45,0,0,0-.44-.28A6.88,6.88,0,0,1,7.86,15c-.08-.17-.08-.37-.34-.37l-.1-.09a.85.85,0,0,1-.8-.85V11.77a.86.86,0,0,1,.85-.86h0c.08,0,.26,0,.26-.19A6.54,6.54,0,0,1,13.88,6,6.36,6.36,0,0,1,20,10.72.41.41,0,0,0,20.36,10.91Z",
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.79,17.53A4.52,4.52,0,0,0,18,12.79v-.11a4.31,4.31,0,0,0-4.2-4.44h-.17a4.35,4.35,0,0,0-4.1,4.54A4.52,4.52,0,0,0,13.79,17.53Z",
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.21,22.21l-2.36-2.38a3.32,3.32,0,0,0-.43.41,3.22,3.22,0,0,1-2.11.68h-.69a3.22,3.22,0,0,1-2.11-.68,5.08,5.08,0,0,0-1-.82,1.7,1.7,0,0,0-2,.32A16.67,16.67,0,0,0,6.39,23L6,23.8c-.14.33-.29.85-.08,1.14a1.71,1.71,0,0,0,1.28.43H16Z",
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.15 20.14 24.62 18.62 22.46 20.79 20.3 18.62 18.77 20.14 20.93 22.31 18.77 24.48 20.3 26 22.46 23.82 24.62 26 26.15 24.48 23.98 22.31 26.15 20.14",
    style: {
      fill: "#e44817"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceQueueDisabled);
export default __webpack_public_path__ + "static/media/presence-queue-disabled.4095f0d4.svg";
export { ForwardRef as ReactComponent };